module.exports = __webpack_public_path__ + "static/media/corporate-services-img71.0611ed05.jpg";